// api url (where your server is hosted at)
const BACKEND_URL = "https://tms.ictlinkcentre.co.ke"
const TOKEN_NAME = "jzfi47e"
const ACCOUNT_DATA = "eyrueu"
const SESSION_DATA = "dfue4r"
export {
  BACKEND_URL,
  TOKEN_NAME,
  ACCOUNT_DATA,
  SESSION_DATA
}
